const TOAST_TYPES = {
  info: "alert-info",
  success: "alert-success",
  warning: "alert-warning",
  error: "alert-danger"
};

export function showToast(message, duration = 2000, type = "info") {
  let flashDiv = document.querySelector("#flash");
  flashDiv.innerHTML = `<div data-alert="alert" class="fade in alert ${TOAST_TYPES[type]}">${message}<a class="close" data-dismiss="alert" href="#">×</a></div`;
  setTimeout(() => {
    flashDiv.firstChild.classList.remove("in");
    flashDiv.innerHTML = "";
  }, duration);
}
